// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__TIHPx","logo":"Landing_logo__oUlXx","buttonContainer":"Landing_buttonContainer__xZUU8"};